import { login_login_user } from "../pages/auth/types/login";

const publicRoutes = ["/login", "/logout"];
// Egasi (2026-09-01): «/orderComments» — zakaz chat endi kontragent uchun
// mustaqil sahifa (pul chat kabi). «Заказы» ro'yxatidan MUSTAQIL.
const clientRoutes = ["/", "/chat", "/moneyComments", "/orderComments", "/orders", "/discounts", "/returnPurchases", "/defects", "/taskCommits", "/taskComments"];

function normalizeModule(mod: string) {
  const m = (mod || "").toLowerCase();
  if (m === "control" || m === "recent") return "recent";
  if (m === "transfers" || m === "transferlog") return "transfers";
  if (m === "moneys" || m === "money") return "money";
  if (m === "goods" || m === "products") return "products";
  if (m === "discounts" || m === "discountedproducts") return "discountedproducts";
  if (m === "sale" || m === "sales") return "sales";
  if (m === "purchase" || m === "purchases") return "purchases";
  if (m === "factorypurchase" || m === "factorypurchases") return "factorypurchases";
  if (m === "returnsale" || m === "returnsales") return "returnsales";
  if (m === "returnpurchase" || m === "returnpurchases") return "returnpurchases";
  if (m === "moneycomments" || m === "moneycomment") return "moneycomments";
  // Zakaz chat: server/seed'da turli nomlar uchraydi — bittaga keltiramiz
  if (m === "ordercomments" || m === "ordercomment" || m === "orderchat") return "ordercomments";
  // Maosh sahifasi Xodimlar (employees) moduli huquqidan foydalanadi
  if (m === "salaries" || m === "salary") return "employees";
  return m;
}

export function isSuperAdmin(user: any): boolean {
  if (!user) return false;
  return (
    user.userName === "Administrator" ||
    user.userName === "Moderator" ||
    user.mainRoles?.resourceName === "super-admin" ||
    user.roleName === "super-admin" ||
    user.role === 1 ||
    user.roleId === 1
  );
}

function isCounterpartyUser(user: any): boolean {
  if (!user) return false;
  return (
    user.userName === "Counterparty" ||
    user.mainRoles?.resourceName === "counterparty" ||
    user.roleName === "counterparty" ||
    (user.counterpartyId != null && user.counterpartyId > 0 && user.managerId == null)
  );
}

// 5-bosqich TZ: zavod kabineti useri (FactoryId bog'langan login)
export function isFactoryUser(user: any): boolean {
  if (!user) return false;
  return (
    user.userName === "Factory" ||
    (user.factoryId != null && user.factoryId > 0 && user.managerId == null && user.counterpartyId == null)
  );
}

// 7-bosqich TZ: do'kon kabineti useri (ShopId bog'langan login)
export function isShopUser(user: any): boolean {
  if (!user) return false;
  // audit F1 (2026-09-04): magazin-TIZIMI admini (o'z tenanti, tenantType=shop_owner) provision'da ShopId ni saqlab
  // qoladi — u kabinet emas, admin (kabinetga yo'naltirilmaydi, ustunlari yashirilmaydi)
  if (Number(user.tenantId || 1) > 1 && (String(user.userType || "").toLowerCase() === "admin" || user.tenantType === "shop_owner")) return false;
  return (
    user.userName === "Shop" ||
    (user.shopId != null && user.shopId > 0 && user.managerId == null &&
      user.counterpartyId == null && user.factoryId == null)
  );
}

export default function hasPermission(
  user: login_login_user | undefined | null,
  path?: string
) {
  if (path === "/" && user?.userName === "Manager") {
    path += "home"
  }

  if (publicRoutes.includes(path || "")) return true;

  // Do'konga chiqarish (2026-09-30): «Правовые страницы» — backend PUT faqat IsMainAdmin (tenant 1, RoleId 1); bola tizim super-admini ko'rmaydi
  if (normalizeModule(path?.split("/")[1] || "") === "legalpages") return Number((user as any)?.tenantId || 1) <= 1 && isSuperAdmin(user);

  // tog'a #3563 2-qism: «Заявки партнёров» faqat glavniy tizimda (server tenant>1 da 403); bola tizim super-admini ham ko'rmaydi
  if (normalizeModule(path?.split("/")[1] || "") === "partnerapplications" && Number((user as any)?.tenantId || 1) > 1) return false;

  if (isSuperAdmin(user)) return true;

  const resourceName = path?.split("/")[1] || "";
  const normResource = normalizeModule(resourceName);
  // Yagona chat (egasi 2026-09-02): «chat» huquqi yo'q bo'lsa ham eski moneyComments/orderComments huquqi yetarli
  if (normResource === "chat" && path !== "/moneyComments" && path !== "/orderComments") {
    const p = (user as any)?.permissions?.find((x: any) => normalizeModule(x.moduleCode) === "chat");
    if (p) return !!p.canRead;
    return hasPermission(user, "/moneyComments") || hasPermission(user, "/orderComments");
  }

  const isDataAdminUser =
    (user as any)?.mainRoles?.resourceName?.toLowerCase() === "dataadmin" ||
    (user as any)?.roleName?.toLowerCase() === "dataadmin";

  if (isDataAdminUser) {
    if (normResource === "dataadmin") return true;
    if (resourceName === "") return true;
    return false;
  }

  // AUDIT 2026-08-31 (kontragent-tizim): quyidagi 4 razdel MENYUDA ko'rinadi
  // (Sidebar'da maxsus qoidalar bilan), lekin ularning `mainPermission` yozuvi
  // YO'Q — shu sabab route-qo'riqchisi ularni 403 qilardi: bo'lim bosilsa
  // «Доступ запрещён» chiqardi. Endi qoidalar Sidebar bilan bir xil.
  // Egasi (2026-09-01): endi katalogda bor — rol matritsasida qatori bo'lsa
  // o'sha hal qiladi (admin olib tashlasa sahifa ham yopiladi), yo'q bo'lsa default.
  const specialRow = (code: string) =>
    (user as any)?.permissions?.find(
      (p: any) => (p.moduleCode || "").toLowerCase() === code
    )
  if (normResource === "globalpanel") {
    const p = specialRow("globalpanel")
    return p ? !!p.canRead : true // S22 default: hammaga ochiq (ma'lumot scope-filtrli)
  }
  if (normResource === "ordertomain") {
    if (Number((user as any)?.tenantId || 1) <= 1) return false
    const p = specialRow("ordertomain")
    return p ? !!p.canRead : true
  }
  if (normResource === "usersdirectory") {
    if (isSuperAdmin(user)) return true
    return !!(user as any)?.permissions?.some(
      (p: any) => (p.moduleCode || "").toLowerCase() === "managers" && (p.showInMenu || p.canRead)
    )
  }
  if (normResource === "declarant") {
    if (isSuperAdmin(user)) return true
    return !!(user as any)?.permissions?.some(
      (p: any) =>
        ["declarations", "contracts"].includes((p.moduleCode || "").toLowerCase()) &&
        (p.showInMenu || p.canRead)
    )
  }

  // DataAdmin and Backups route permission check for admin roles
  if (normResource === "dataadmin" || normResource === "backups") {
    // tog'a #1940 kampaniyasi (2026-09-14): menyu backend bilan bir xil — avval rol matritsasida backups/dataAdmin bo'lgan menejer
    // bandlarni ko'rardi, backend esa 403 berardi (o'lik menyu). Backend: BackupsController.IsAdminUser (faqat tenant 1:
    // super-admin yoki Administrator/Moderator), DataAdminController.HasDataAdminAccess (faqat tenant 1: super-admin yoki DataAdmin roli).
    if (Number((user as any)?.tenantId || 1) > 1) return false
    if (isSuperAdmin(user)) return true
    if (normResource === "dataadmin") return isDataAdminUser
    return ["administrator", "moderator"].includes(String((user as any)?.userName || "").toLowerCase())
  }

  if (isCounterpartyUser(user)) {
    if (resourceName === "") return true; // allow home dashboard
    // 2026-08-30 egasi talabi: admin "Роли и права"da Контрагент roli uchun
    // belgilagan huquqlar ISHLASHI kerak — dinamik ro'yxat bo'lsa o'sha hal
    // qiladi (belgilanmagan bo'lim = kirish yo'q). taskCommits/taskComments
    // rol sahifasida boshqarilmaydi — ular eski ro'yxat bo'yicha qoladi.
    if (user?.permissions && user.permissions.length > 0) {
      const p = user.permissions.find((x: any) => normalizeModule(x.moduleCode) === normResource);
      if (p) return !!p.canRead;
      if (resourceName === "taskCommits" || resourceName === "taskComments")
        return !!clientRoutes.find((x) => x === "/" + resourceName);
      // Egasi (2026-09-01): zakaz chat kontragentga HAR DOIM ochiq —
      // pul chat kabi. Bazadagi eski rollarda «orderComments» huquqi
      // umuman yaratilmagan (2026-06-15 seed'da unutilgan), shuning uchun
      // huquq qatori topilmasa ham chat yopilmaydi: bu kontragentning
      // O'Z suhbati, server baribir faqat o'ziniki bilan cheklaydi.
      if (normResource === "ordercomments" || normResource === "chat" || normResource === "moneycomments") return true;
      return false;
    }
    return !!clientRoutes.find((x) => x === "/" + resourceName);
  }

  // Zavod useri FAQAT o'z kabinetiga (jo'natmalar) kiradi — izolyatsiya
  if (isFactoryUser(user)) {
    if (resourceName === "") return true; // home -> kabinetga redirect qiladi
    return resourceName === "factoryShipments";
  }

  // Do'kon useri o'z kabinetiga hamisha kiradi (qo'shimcha huquqlari bo'lsa
  // ular quyidagi umumiy permissions mantig'ida tekshiriladi — bloklanmaydi)
  if (isShopUser(user)) {
    if (resourceName === "") return true;
    if (resourceName === "shopCabinet") return true;
  }

  // Dynamic permissions from backend (works for Manager, etc.)
  if (user?.permissions && user.permissions.length > 0) {
    if (resourceName === "") return true; // allow home by default if authenticated
    
    const p = user.permissions.find((x: any) => normalizeModule(x.moduleCode) === normResource);
    if (p) return p.canRead;
  }

  return !!user?.manager?.managerRole?.find(
    (role: any) => normalizeModule(role?.permission?.resourceName || "") === normResource
  );
}

export function usePermission(user: login_login_user | undefined | null, moduleCode: string) {
  if (!user) return { canRead: false, canCreate: false, canEdit: false, canDelete: false, showInMenu: false };
  
  if (isSuperAdmin(user)) {
    return { canRead: true, canCreate: true, canEdit: true, canDelete: true, showInMenu: true };
  }

  const normCode = normalizeModule(moduleCode);

  if (normCode === "dataadmin") {
    const isDataAdmin =
      (user as any)?.mainRoles?.resourceName === "DataAdmin" ||
      (user as any)?.roleName === "DataAdmin" ||
      user?.permissions?.some((p: any) => normalizeModule(p.moduleCode) === "dataadmin" && p.canRead) ||
      user?.manager?.managerRole?.some((r: any) => normalizeModule(r?.permission?.resourceName || "") === "dataadmin");

    return {
      canRead: !!isDataAdmin,
      canCreate: !!isDataAdmin,
      canEdit: !!isDataAdmin,
      canDelete: !!isDataAdmin,
      showInMenu: !!isDataAdmin
    };
  }

  if (isCounterpartyUser(user)) {
    // Dinamik rol-huquqlar ustuvor (2026-08-30): qator bor — o'sha flaglar,
    // qator yo'q — faqat task sahifalari eski ro'yxatdan, qolgani yopiq.
    if (user.permissions && user.permissions.length > 0) {
      const p = user.permissions.find((x: any) => normalizeModule(x.moduleCode) === normCode);
      if (p) {
        return {
          canRead: !!p.canRead,
          canCreate: !!p.canCreate,
          canEdit: !!p.canEdit,
          canDelete: !!p.canDelete,
          showInMenu: !!p.showInMenu
        };
      }
      const isTask = moduleCode === "taskCommits" || moduleCode === "taskComments";
      const taskAllowed = isTask && !!clientRoutes.find((x) => x === "/" + moduleCode);
      return { canRead: taskAllowed, canCreate: taskAllowed, canEdit: taskAllowed, canDelete: taskAllowed, showInMenu: taskAllowed };
    }
    const isAllowed = clientRoutes.find((x) => x === "/" + moduleCode);
    return {
      canRead: !!isAllowed,
      canCreate: !!isAllowed,
      canEdit: !!isAllowed,
      canDelete: !!isAllowed,
      showInMenu: !!isAllowed
    };
  }

  if (user.permissions && user.permissions.length > 0) {
    const p = user.permissions.find((x: any) => normalizeModule(x.moduleCode) === normCode);
    if (p) {
       return {
         canRead: !!p.canRead,
         canCreate: !!p.canCreate,
         canEdit: !!p.canEdit,
         canDelete: !!p.canDelete,
         showInMenu: !!p.showInMenu
       };
    }
  }

  const legacyRole = user.manager?.managerRole?.find(
    (role: any) => normalizeModule(role?.permission?.resourceName || "") === normCode
  );
  
  return { 
    canRead: !!legacyRole, 
    canCreate: !!legacyRole, 
    canEdit: !!legacyRole, 
    canDelete: !!legacyRole, 
    showInMenu: !!legacyRole 
  };
}

// Boshliq «Menejer huquqlari» (2026-09-14): usePermission hook EMAS (oddiy funksiya, useContext chaqirmaydi). Nomi «use» bilan boshlangani
// uchun eslint (react-hooks/rules-of-hooks) uni komponent tashqarisida/shartli chaqirishga yo'l qo'ymaydi — shunday joylar uchun oddiy nom.
export const modulePermission = usePermission
